import { AxiosLikeError } from './types';

export const isAxiosError = (error: unknown): error is AxiosLikeError =>
  error instanceof Error &&
  (error as Partial<AxiosLikeError>).isAxiosError === true;

export const describeApiError = (error: AxiosLikeError) => {
  const method = error.config?.method?.toUpperCase() ?? 'UNKNOWN';
  const url = error.config?.url ?? 'unknown URL';
  const status = error.response?.status ?? 'no response';
  return { method, url, status, message: `${method} ${url} — ${status}` };
};

export const createApiError = (axiosError: AxiosLikeError, message: string) => {
  const apiError = new Error(message, { cause: axiosError });
  apiError.name = 'ApiError';
  apiError.stack = axiosError.stack;
  return apiError;
};
